import React from 'react';

export const TowaryCenaLazy = React.lazy(() =>
  import('./TowaryCena/TowaryCena')
);

export const KategorieProduktoweLazy = React.lazy(() =>
  import('./KategorieProduktowe/KategorieProduktowe')
);

export const KategorieTowaryPolaczLazy = React.lazy(() =>
  import('./KategorieTowaryPolacz/KategorieTowaryPolacz')
);

export const TowarKategoriePolaczLazy = React.lazy(() =>
  import('./TowarKategoriePolacz/TowarKategoriePolacz')
);

export const TowaryPowiazaniaLazy = React.lazy(() =>
  import('./TowaryPowiazania/TowaryPowiazania')
);

export const TlumaczeniaSeoLazy = React.lazy(() =>
  import('./TlumaczeniaSeo/TlumaczeniaSeo')
);

export const TlumaczeniaRoutesLazy = React.lazy(() =>
  import('./TlumaczeniaRoutes/TlumaczeniaRoutes')
);

export const TowaryPowiazaniaCechyWspolneLazy = React.lazy(() =>
  import('./TowaryPowiazaniaCechyWspolne/TowaryPowiazaniaCechyWspolne')
);

export const TowaryPowiazaniaWarunkiLazy = React.lazy(() =>
  import('./TowaryPowiazaniaWarunki/TowaryPowiazaniaWarunki')
);

export const TowaryImportExportLazy = React.lazy(() =>
  import('./TowaryImportExport/TowaryImportExport')
);

export const KreatoryProduktowLazy = React.lazy(() =>
  import('./KreatoryProduktow/KreatoryProduktow')
);

export const KreatoryModeleLazy = React.lazy(() =>
  import('./Kreatory/Kreatory')
);

export const KreatorDefinicjeTypyLazy = React.lazy(() =>
  import('./KreatorDefinicjeTypy/KreatorDefinicjeTypy')
);

export const CechyWariantyLazy = React.lazy(() =>
  import('./CechyWarianty/CechyWarianty')
);

export const CechyZdjeciaTypyLazy = React.lazy(() =>
  import('./CechyZdjeciaTypy/CechyZdjeciaTypy')
);

export const CechyPlikiTypyLazy = React.lazy(() =>
  import('./CechyPlikiTypy/CechyPlikiTypy')
);

export const CechyKanalyTypyLazy = React.lazy(() =>
  import('./CechyKanalyTypy/CechyKanalyTypy')
);

export const CechyTowaryTypyWariantyDostepne = React.lazy(() =>
  import('./CechyTowaryTypyWariantyDostepne/CechyTowaryTypyWariantyDostepne')
);

export const CechyTowaryTypyEdycjaLazy = React.lazy(() =>
  import('./CechyTowaryTypyEdycja/CechyTowaryTypyEdycja')
);

export const CechyTowaryTypySzablonyLazy = React.lazy(() =>
  import('./CechyTowaryTypySzablony/CechyTowaryTypySzablony')
);

export const CechyTowaryModeleLazy = React.lazy(() =>
  import('./CechyTowaryModele/CechyTowaryModele')
);

export const CechyTowaryMarkiLazy = React.lazy(() =>
  import('./CechyTowaryMarki/CechyTowaryMarki')
);

export const CechySlownikiLazy = React.lazy(() =>
  import('./CechySlowniki/CechySlowniki')
);

export const JednostkiMiarLazy = React.lazy(() =>
  import('./JednostkiMiar/JednostkiMiar')
);

export const CechyPageLazy = React.lazy(() => import('./Cechy/Cechy'));

export const OpisywanieTowarowPageLazy = React.lazy(() =>
  import('./OpisywanieTowarow/OpisywanieTowarow')
);

export const TowarPodgladPageLazy = React.lazy(() =>
  import('./TowarPodglad/TowarPodglad')
);

export const ZamowienieEdycjaLazy = React.lazy(() =>
  import('./ZamowienieEdycja/ZamowienieEdycja')
);

export const CechyTowaryTypyPageLazy = React.lazy(() =>
  import('./CechyTowaryTypy/CechyTowaryTypy')
);

export const FormyPlatnosciPageLazy = React.lazy(() =>
  import('./FormyPlatnosci/FormyPlatnosci')
);

export const TowaryOpinieLazy = React.lazy(() =>
  import('./TowaryOpinie/TowaryOpinie')
);

export const KomunikatoryLazy = React.lazy(() =>
  import('./Komunikator/Komunikator')
);

export const CenyWyliczonePageLazy = React.lazy(() =>
  import('./CenyWyliczone/CenyWyliczone')
);

export const KrajePageLazy = React.lazy(() => import('./Kraje/Kraje'));

export const PromoPageLazy = React.lazy(() => import('./Promo/Promo'));

export const RabatyPageLazy = React.lazy(() => import('./Rabaty/Rabaty'));

export const CechyGrupyPageLazy = React.lazy(() =>
  import('./CechyGrupy/CechyGrupy')
);

export const SklepyTowaryWyklczenia = React.lazy(() =>
  import('./WykluczeniaNaSklepach/WykluczeniaNaSklepach')
);

export const WiadomosciSzablony = React.lazy(() =>
  import('./WiadomosciSzablony/WiadomosciSzablony')
);

export const KlienciListaPageLazy = React.lazy(() =>
  import('./KlienciLista/KlienciLista')
);

export const ReklamyPageLazy = React.lazy(() => import('./Reklamy/Reklamy'));

export const RaportyStartowePageLazy = React.lazy(() =>
  import('./RaportyStartowe/RaportyStartowe')
);

export const TransactionsWithActionsPageLazy = React.lazy(() =>
  import('./TransactionsWithActions/TransactionsWithActions')
);

export const ZamowieniaPageLazy = React.lazy(() =>
  import('./Zamowienia/Zamowienia')
);

export const ParametryPageLazy = React.lazy(() =>
  import('./Parametry/Parametry')
);

export const Cenniki = React.lazy(() => import('./Cenniki/Cenniki'));

export const WalutyPageLazy = React.lazy(() => import('./Waluty/Waluty'));

export const SklepyPageLazy = React.lazy(() => import('./Sklepy/Sklepy'));

export const UzytkownicyPageLazy = React.lazy(() =>
  import('./Uzytkownicy/Uzytkownicy')
);

export const TowaryPageLazy = React.lazy(() =>
  import('./TowaryLista/TowaryLista')
);

export const CiagiNumeracjePageLazy = React.lazy(() =>
  import('./CiagiNumeracji/CiagiNumeracji')
);

export const JezykiPageLazy = React.lazy(() => import('./Języki/Jezyki'));

export const LogiTestPageLazy = React.lazy(() => import('./Logi/Logi'));

export const TlumaczeniaPageLazy = React.lazy(() =>
  import('./Tlumaczenia/Tlumaczenia')
);

export const KategoriePageLazy = React.lazy(() =>
  import('../pages/Kategorie/Kategorie')
);

export const KategorieCechyPageLazy = React.lazy(() =>
  import('./KategorieCechy/KategorieCechyPage')
);

export const StronyStatycznePageLazy = React.lazy(() =>
  import('./StronyStatyczne/StronyStatyczne')
);

export const BlogPageLazy = React.lazy(() =>
  import('./Blog/Blog')
);

export const FileUploaderPageLazy = React.lazy(() =>
  import('./FileUploader/FileUploader')
);
export const AnkietyPageLazy = React.lazy(() => import('./Ankiety/Ankiety'));

export const WysylkiCzasyDostawyLazy = React.lazy(() => import('./WysylkiCzasyDostawy/WysylkiCzasyDostawyLista'));


export const WalidacjaImion = React.lazy(() =>
  import('./Walidacje/WalidacjeImion/WalidacjeImion')
);
export const WalidacjeKodowPocztowych = React.lazy(() =>
  import('./Walidacje/WalidacjeKodowPocztowych/WalidacjeKodowPocztowych')
);

export const UzytkownicyWebCzarnaListaListaLazy = React.lazy(() =>
  import('./UzytkownicyCzarnaLista/UzytkownicyCzarnaListaLista')
);

export const Import = React.lazy(() => import('./Import/Import'));
